export const ApplicationStep = {
  AGENT_SELECTION: 'AGENT_SELECTION',
  REFERENCES: 'REFERENCES',
  DEFAULT_CART: 'DEFAULT_CART',
  AUTO_CART: 'AUTO_CART',
  KTUIN_CART: 'KTUIN_CART',
  PAYMENT_METHOD: 'PAYMENT_METHOD',
  CONTACT_INFORMATION: 'CONTACT_INFORMATION',
  CHECKOUT_SESSION_CREATION: 'CHECKOUT_SESSION_CREATION',
} as const;

export type ApplicationStepValue = (typeof ApplicationStep)[keyof typeof ApplicationStep];
